import axios from 'axios';
import store from '@/store/store';

export default function execute() {
    const apiVersion = "v1";

    axios.interceptors.request.use(function(config) {
        //SET VARS
        var url = config.url;
        const token = store.state.userInfo.token;

        //ROUTE API CALLS THROUGH THE VERSIONED PATH
        if (url.startsWith("/api/")) {
            url = "/api/" + apiVersion + "/" + url.substring(5);
            config.url = url;
        }

        //IF TOKEN, ADD TO CALL
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });
}


// WEBPACK FOOTER //
// ./src/helpers/httpInterceptor.js